import { Slot, Stack } from "expo-router";

import { isWeb } from "@stepapp/core";
import { palette, spacing } from "@stepapp/ui";

const CalendarReservarionLayout = () => {
  return (
    <>
      {isWeb ? (
        <Slot />
      ) : (
        <Stack
          screenOptions={{
            headerShown: false,
            contentStyle: {
              backgroundColor: palette.common.white,
              paddingHorizontal: spacing.unit * 2.5,
            },
          }}
        >
          <Stack.Screen
            name="index"
            options={{
              headerShown: false,
            }}
          />
          <Stack.Screen
            name="assigned-worker"
            options={{
              headerShown: false,
            }}
          />
          <Stack.Screen
            name="rating"
            options={{
              headerShown: false,
              contentStyle: {
                paddingHorizontal: 0,
                backgroundColor: palette.common.white,
              },
            }}
          />
          <Stack.Screen
            name="payment-method"
            options={{
              animation: "slide_from_bottom",
              presentation: "modal",
            }}
          />
          <Stack.Screen
            name="edit-reservation"
            options={{
              animation: "slide_from_bottom",
              presentation: "modal",
              contentStyle: {
                marginHorizontal: 0,
                backgroundColor: palette.common.white,
              },
            }}
          />
        </Stack>
      )}
    </>
  );
};

export default CalendarReservarionLayout;
